import {useCatalog, useCatalogDispatch} from "../../store/catalog";
import {FilterPanel} from "../catalog/FilterPanel";
import {SearchBox} from "../catalog/SearchBox";
import {useEffect} from "@wordpress/element";

export const FilterHost = () => {
    const {sort, stagedFilterValues, stagedSearch, filterConfigs} = useCatalog();
    const dispatch = useCatalogDispatch();


    // Wire up WP header menu button -> open this drawer
    useEffect(() => {
        const menuBtn = document.getElementById("pt-header-menu-btn");
        if (!menuBtn) return;

        const onMenuClick = (e) => {
            e.preventDefault();

            const drawer = document.getElementById("filter-drawer");
            if (!drawer) return;

            dispatch.syncStagedFilters();
            drawer.checked = true;
        };

        menuBtn.addEventListener("click", onMenuClick);
        return () => menuBtn.removeEventListener("click", onMenuClick);
    }, [dispatch]);

    const handleApply = () => {
        dispatch.applyFilters();
        const drawer = document.getElementById("filter-drawer");
        if (drawer) drawer.checked = false;
    };

    return (
        <div className="drawer !z-[1001]">
            <input
                id="filter-drawer"
                type="checkbox"
                className="drawer-toggle"
                onChange={(e) => {
                    if (e.target.checked) {
                        dispatch.syncStagedFilters();
                    }
                }}
            />

            {/* No floating filter button anymore */}
            <div className="drawer-content"/>

            <aside className="drawer-side">
                <label htmlFor="filter-drawer" className="drawer-overlay"></label>

                <div className="bg-white h-full w-[350px] flex flex-col p-8">
                    <div className="flex-1 overflow-y-auto no-scrollbar">
                        <div className="flex items-center gap-4 mb-4 border-b border-base-200 pb-4">
                            <label
                                htmlFor="filter-drawer"
                                className="cursor-pointer pt-dark-blue hover:opacity-70 transition-opacity"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </label>
                            <h2 className="text-2xl font-black pt-dark-blue m-0">Filters</h2>
                        </div>

                        <SearchBox/>
                        <FilterPanel/>
                    </div>

                    <div className="pt-filter-footer flex gap-4 pt-6 border-t border-base-200">
                        <button className="btn pt-btn-pill pt-btn-apply flex-1" onClick={handleApply}>
                            Apply
                        </button>
                        <button
                            className="btn pt-btn-pill pt-btn-clear flex-1"
                            onClick={() => dispatch.resetStagedFilters()}
                        >
                            Clear
                        </button>
                    </div>
                </div>
            </aside>
        </div>
    );
};